import { render, staticRenderFns } from "./examinationEdit.vue?vue&type=template&id=ec803a54&scoped=true&"
import script from "./examinationEdit.vue?vue&type=script&lang=js&"
export * from "./examinationEdit.vue?vue&type=script&lang=js&"
import style0 from "./examinationEdit.vue?vue&type=style&index=0&id=ec803a54&prod&lang=less&"
import style1 from "./examinationEdit.vue?vue&type=style&index=1&id=ec803a54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec803a54",
  null
  
)

export default component.exports